<template>
    <rkm-modal
        large
        ref="RkmModal"
        title="Protocolo"
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Nome"
                    v-model="data.model.oci.nome"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Linha de cuidado"
                    v-model="data.model.oci.linhaCuidado"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    disabled
                    label="Etapas concluídas"
                    v-model="data.model.oci.etapasConcluidas"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Etapa clínica atual"
                    v-model="data.model.oci.etapaClinicaAtualNome"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    disabled
                    label="Prazo de validade"
                    v-model="data.model.oci.prazoValidade"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input
                    disabled
                    label="Profissional que iniciou o protocolo"
                    v-model="data.model.oci.usuarioQueIniciou"
                />
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
export default {
    methods: {
        open() {

            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>